import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import login from '@/view/login'
import register from '@/view/register'
import success from '@/view/success'
import examine from '@/view/examine'
import helpCenter from '@/view/help_center/index' //帮助中心 申请须知
import help from '@/view/help/index' //帮助中心
import announcement from '@/view/announcement/index' //登记公告

// 首页
import index from '@/view/V2/index' //登记公告
import searchResult from '@/view/V2/searchResult' //登记公告
import workDetails from '@/view/V2/workDetails' //登记公告
import www from '@/view/V2/w' //登记公告
import rules from '@/view/V2/rules' //登记公告
import finance from '@/view/V2/finance' //登记公告
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
}



Vue.use(Router)

const router = new Router({
    routes: [{
            path: '/',
            name: 'ex',
            component: index
        },
        {
            path: '/finance',
            name: 'finance',
            component: finance
        },
        {
            path: '/rules',
            name: 'rules',
            component: rules
        }, {
            path: '/search',
            name: 'search',
            component: searchResult
        },
        {
            path: '/workDetails',
            name: 'workDetails',
            component: workDetails
        },

        {
            path: '/www',
            name: 'w',
            component: www
        },

        {
            path: '/menu',
            name: 'HelloWorld',
            component: HelloWorld
        },
        // {
        //     path: '/',
        //     name: 'HelloWorld',
        //     component: HelloWorld
        // },
        {
            path: '/login',
            name: 'login',
            component: login,
            meta: { allowBack: false }
        },
        {
            path: '/register',
            name: 'register',
            component: register
        },
        {
            path: '/success',
            name: 'success',
            component: success
        },
        {
            path: '/examine',
            name: 'examine',
            component: examine
        },
        {
            path: '/home',
            name: 'home',
            component: () =>
                import ( /*webpackChunkName:"home" */ '@/view/home/home')
        },
        {
            path: '/copyright',
            name: 'copyright',
            component: () =>
                import ( /*webpackChunkName:"copyright" */ '@/view/copyright/index')
        },
        {
            path: '/help_center', //帮助中心 申请须知
            name: 'helpCenter',
            component: helpCenter
        },
        {
            path: '/help', //帮助中心
            name: 'help',
            component: help
        },
        {
            path: '/announcement', //登记公告
            name: 'announcement',
            component: announcement
        },
        {
            path: '/computer', // 计算机
            name: 'computer',
            component: () =>
                import ( /*webpackChunkName:"computer" */ '@/view/copyright/computer')
        },
    ]
})
router.beforeEach((to, from, next) => {
    console.log(from)
    if (from.name == 'search' && to.name == 'search') {
        next()
        return
    }
    document.body.scrollTop = 0
        // firefox
    document.documentElement.scrollTop = 0
    next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js